import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import banner1 from '../assets/images/banner1.jpg';
import banner2 from '../assets/images/banner2.jpg';
import banner3 from '../assets/images/banner3.jpg';
import {BsBoxArrowUpRight, BsSend, BsAt, BsGeoAltFill } from "react-icons/bs";
import { ModalContext } from '../context/ModalContext';
import axiosInstance from '../axiosInstance';

const Projects = () => {
    const modalContext = useContext(ModalContext);
    const [projectDetails, setProjectDetails] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axiosInstance.get("/api/getprojectshome"); // Adjust port if needed
                const fetchedData = res.data; // Assuming data is an array
                setProjectDetails(fetchedData);
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        };
        fetchData();
    }, []);

    return (
        <>
        <section className="home-projects py-12">
            <div className="container mx-auto">
                <div className="flex text-center items-center justify-center w-full md:w-2/4 mx-auto mb-7">
                    <div className="home-projects-head flex flex-col text-center items-center justify-center align-middle ">
                        <h2 className="relative text-2xl leading-8 font-bold uppercase font-montserrat mb-2">
                            <span className="absolute top-1/2 -left-14 -mt-px h-0.5 w-12 bg-orange-400"></span>
                            <span className=' text-slate-500 font-thin'>Our</span> Projects
                            <span className="absolute top-1/2 -right-14 -mt-px h-0.5 w-12 bg-orange-400"></span>
                            </h2>
                        <div className="text-md leading-6 ms-auto me-auto">
                            <span className=' font-semibold '>Urbanaid Infratech</span>, we are available to provide green residential property in Lucknow, Uttar Pradesh, India. We cordially welcome you to<br></br><span className='font-semibold '>Urbanaid Uniworld, India Green City and Taj Enclave</span>.
                        </div>
                    </div>
                </div>
            </div>
            <div className="container mx-auto">
                <div className="flex">
                    <div className="grow grid grid-flow-row auto-rows-auto grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center">
                        {Array.isArray(projectDetails) && projectDetails.map((detail) => {
                            const projectUrl = detail.projectname?.toLowerCase().replace(/\s+/g, '-') || '';
                             return (
                        <div className='projects-wrap relative grow overflow-hidden rounded-xl bg-white border border-gray-300 hover:shadow-xl' key={detail.id}>
                            <div className='flex'>
                                <div className='project-img relative grow'>
                                    <div className='w-full h-56 relative overflow-hidden flex justify-center items-center'>                                        
                                        {detail.status?.trim().toLowerCase() === 'inactive' && (
                                        <div className='flex items-center justify-center absolute top-0 left-0 min-w-24 text-nowrap bg-red-600 text-white py-1 rounded-br-xl'>Sold Out</div>
                                        )}
                                        {/* <div className='w-full h-full relative overflow-hidden'> */}
                                            <img src={`${detail.image}`} alt={detail.alt || detail.projectname} className='w-full h-auto transition-all ease-in duration-500' />
                                        {/* </div> */}
                                    </div>
                                    <div className='w-full h-auto p-4 pt-2 relative'>
                                        <h3 className='text-lg leading-8 font-semibold uppercase text-gray-900 '>{detail.projectname}</h3>
                                        <div className='flex flex-row text-sm gap-1 min-h-[56px]'>
                                            <span className='text-base pt-1 text-gray-400'><BsGeoAltFill /></span><span>{detail.siteaddress}</span>
                                        </div>
                                        <div className='w-full flex justify-between items-center mt-2 pt-3 border-t border-gray-200 border-solid'>
                                            <div className='flex flex-row text-gray-500 justify-start items-center gap-1'>
                                                <span className='block text-sm'>Start</span>
                                                <span className='block text-base'><BsAt /></span>
                                                <span className='block text-base font-semibold text-slate-600 font-roboto'>Rs. {detail.startat} / sq.ft.</span>
                                            </div>
                                            <div className='flex flex-row gap-2'>
                                                <Link to={`/projects/${projectUrl}`} className='text-gray-800 text-base px-2 py-2  rounded hover:bg-orange-500 hover:text-white' data-tooltip-id="my-tooltip" data-tooltip-content="See Project" data-tooltip-place="top">
                                                    <BsBoxArrowUpRight />
                                                </Link>
                                                <button type='button' className='text-gray-800 text-base px-2 py-2  rounded hover:bg-orange-500 hover:text-white' data-tooltip-id="my-tooltip" data-tooltip-content="Send Enquiry" data-tooltip-place="top" onClick={() => {
                                                    modalContext.setShowEnquiryPopup(true);
                                                }}>
                                                    <BsSend />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )
                        }
                        )}
                    </div>
                    <Tooltip id="my-tooltip" />
                </div>
            </div>
        </section>
        </>
    );
}

export default Projects;
